const events = {
    AT_STATUS_CHANGED: 'AT_STATUS_CHANGED',
    LOGGED_IN: 'logged_in',
    LOGGING_IN: 'logging_in',
    FAILED_LOGIN: 'failed_login',
    LOGGED_OUT: 'logged_out',
    LOGGED_IN_AUTHORIZED: 'logged_in_authorized',
    HTTP_UNAUTHORIZED: 'http_unauthorized',
    INBOX_LOADED: 'inbox_loaded',
    INBOX_UPDATED: 'inbox_updated',
    CENTRES_LOADED: 'centres_loaded',
    CENTRES_UPDATED: 'centres_updated',
    WINZ_RATES_LOADED: 'winz_rates_loaded',
    WINZ_RATES_UPDATED: 'winz_rates_updated',
    CHILD_MATCHES_LOADED: 'child_matches_loaded',
    CHILD_MATCHES_UPDATED: 'child_matches_updated',
    EXPORT_LOADED: 'export_loaded',
    EXPORT_UPDATED: 'export_updated',
    ENTRIES_LOADED: 'entries_loaded',
    ENTRIES_UPDATED: 'entries_updated',
    STATS:{
        EMAIL_LOADED: 'stats.email.loaded',
        ISSUES_LOADED: 'stats.issues.loaded',
        GRAND_TOTALS_LOADED: 'stats.grand.totals.loaded',
    },
    SIGNALR:{
        WINZ_EMAIL_DATA_CHANGES: 'winz.email.data.changes',
        WINZ_EMAIL_DATA_DELETE: 'winz.email.data.delete',
        WINZ_CENTRE_DATA_CHANGES: 'winz.centre.data.changes',
        WINZ_RATES_DATA_CHANGES: 'winz.rates.data.changes',
        WINZ_CHILD_MATCH_DATA_CHANGES: 'winz.childmatch.data.changes',
        WINZ_ENTRY_DATA_CHANGES: 'winz.entry.data.changes',
        WINZ_ENTRY_DATA_DELETED: 'winz.entry.data.delete',
        EMAIL_PROCESSING_STATUS: 'email.processing.status',
        WINZ_EXPORT_DATA_CHANGES: 'winz.batch.data.changes',
        WINZ_EXPORT_DELETED: 'winz.batch.data.delete',
        WINZ_CENTRE_DATA_SYNC: 'winz.centre.data.sync',
    }
};

export default events;